import { get } from '../api.service';

export interface AnalysisData {
  month: string;
  year1Amount: number;
  year2Amount: number;
}

export interface AnalysisResponse {
  statusCode: number;
  message: string;
  response: {
    year1: number;
    year2: number;
    data: AnalysisData[];
  };
  totalCount: number;
  numberOfPages: number;
}

export interface AnalysisParams {
  year1?: number;
  year2?: number;
}

export const fetchAnalysisData = async (params: AnalysisParams = {}): Promise<AnalysisResponse> => {
  try {
    const { year1 = new Date().getFullYear() - 1, year2 = new Date().getFullYear() } = params;
    const response = await get(`userdashboard/analysis?year1=${year1}&year2=${year2}`);
    return response;
  } catch (error) {
    console.error('Error fetching analysis data:', error);
    throw error;
  }
};